<div class="header">
  <h5>Documents de la facture</h5>
  <mat-icon class="col-md-12" class="close-button" (click)="onModalCancel()" color="primary">cancel</mat-icon>
  <mat-divider></mat-divider>
</div>
<div class="mat-dialog-content">
  <div style="margin-top: 20px;">
    <div class="myRow" *ngFor="let document of data.documents;">
      <div class="doc">
        {{document.code}}
      </div>
      <div class="btn" *ngIf="document.path !== data.bp.get('urlFacture').value">
        <button mat-raised-button color="primary" 
        (click)="onOpenDoc(document, data.idBp)" >
          <mat-icon>get_app</mat-icon> </button>
      </div>
      <div class="btn" >
        <button mat-raised-button color="primary" 
        (click)="document.path !== data.bp.get('urlFacture').value ? visualiseDoc(document, data.idBp)  : openUrl()">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
      </div>
      <!-- 
        Dans le cas où l'on veux ajouter la possibilité de supprimer un document
        <div class="col-sm-2">
        <button mat-raised-button color="danger" (click)="onDeleteDoc(document, data.idBc)"><mat-icon>delete</mat-icon></button>
        </div>
      -->
    </div>
  </div>
</div>